/**
 * A global namespace for `mouseup` event.
 */
const mouseupEvent = "mouseup";
export default mouseupEvent;
